<div class="e-sku-count" *ngIf="displaySkuCount" aria-live="polite">
    <strong>Total number of SKUs: <span class="e-sku-total">{{skuCount | number}}</span></strong><br />
    <ng-container *ngIf="showMaxDateRange()">
        Based on the number of SKU's, a maximum date range of {{maxDateRange}} days can be selected.
    </ng-container>
    <ng-container>
        The final number of SKUs in your file may not match the number shown here as SKUs not present in the selected time series will be excluded.
    </ng-container><br />
    <ng-container *ngIf="showMessage()">
        {{message}}
    </ng-container>
</div>
